<template>
    <div class="DialogReportPaid__Component">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">הוספת קובץ</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <div class="DialogReportPaid__Component__Loading">
                    <div>
                        <b-field label="בחירת קובץ">
                            <b-upload v-model="file" accept=".png,.jpg,.pdf,.jpeg,.mp3" class="file-label">
                                <span class="file-cta">
                                    <b-icon class="file-icon" icon="upload"></b-icon>
                                    <span class="file-label">בחירת קובץ</span>
                                </span>
                                <span class="file-name" v-if="file">
                                    {{ file.name }}
                                </span>
                            </b-upload>
                        </b-field>
                    </div>
                    <b-field style="margin-top: 10px;" label="לאן להעלות">
                        <FieldInlineSelect style="width: 50%;" label="" :filterable="false" :clearable="false" :options="[{ Value: 1, Text: 'כללי' },
                        { Value: 2, Text: 'ספרים' }, { Value: 3, Text: 'הודעות' }, { Value: 5, Text: 'הרצאות' }, { Value: 6, Text: 'דואר אלקטרוני' }, { Value: 7, Text: 'דף הבית' }, { Value: 8, Text: 'חקיקה' }, { Value: 9, Text: 'כרטיסיות' }]" required="true"
                            v-model="folderType" />
                    </b-field>
                </div>
            </section>
            <footer class="modal-card-foot">
                <b-button :loading="isLoading" @click="save" label="שמור" type="is-primary" />
                <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
import { ToastProgrammatic as Toast } from "buefy";
import AdminService from "../services/AdminService";
import FieldInlineSelect from "@/components/Fields/FieldInlineSelect.vue";

export default {
    name: "DialogAddUser",
    props: ["onSuccess"],
    components: {
        FieldInlineSelect
    },
    created() {
    },
    data() {
        return {
            isLoading: false,
            file: null,
            folderType: 1
        };
    },
    methods: {
        save() {
            this.isLoading = true;
            const formData = new FormData();
            formData.append('file', this.file);
            AdminService.uploadFileToStorage(this.folderType, formData)
                .then(() => {
                    this.$emit("customEvent")
                    this.$emit("close");
                }).catch(() => {
                    Toast.open({
                        type: "is-danger",
                        message: 'הפעולה נכשלה',
                        duration: 8000,
                    });
                }).finally(() => {
                    this.isLoading = false;
                })
        },
    },
};
</script>

<style scoped lang="scss">
.courses,
.tracks {
    max-height: 200px;
    margin: 10px 0;
    overflow: auto;
}
</style>
<style>
.import__students__container {
    box-shadow: inset 1px 1px 6px;
    overflow: auto;
    max-height: 500px;
    padding: 5px;
}

.existed__student {
    border-bottom: 4px solid whitesmoke;
}
</style>
